'use client';

import React from 'react';
import styled from '@emotion/styled';
import { colors, size, breakpoints } from "@argo/principles";
import { NAV_HEIGHT } from '../utils/constants';
export const MobileMenuWrapper = styled('div')`
  background: ${colors.primary.marineBlue};
  width: 100vw;
  right: -100vw;
  top: ${NAV_HEIGHT}px;
  position: fixed;
  transition: transform .4s ease;
  transform: translate3d(0, 0, 0);
  overflow: auto;
  padding: ${size.sm}px 0px ${size.xl}px;
  height: calc(100% - ${NAV_HEIGHT}px);
  
  will-change: transform;
  contain: layout style paint;
  backface-visibility: hidden;
  
  /* react-transition-group styles */
  &.enter-active, &.enter-done {
    transform: translate3d(-100%, 0, 0);
  }

  /* set z-index to 100 when exiting so other components don't go over the menu */
  &.exit-active {
    z-index: 100;
  }


  @media (min-width: 480px) {
    right: -75vw;
    width: 75vw;
  };

  @media (min-width: ${breakpoints.lg}px) {
    right: -50vw;
    width: 50vw;
  }
`;
const MobileDropdownBase = styled('div')`
  list-style-type: none;
  margin: 0;
  width: 100%;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-bottom: ${size.sm}px;
`;
const MobileMenu = React.forwardRef(({
  children
}, ref) => {
  return React.createElement(MobileMenuWrapper, {
    ref: ref
  }, React.createElement(MobileDropdownBase, null, children));
});
MobileMenu.displayName = 'MobileMenu';
export default MobileMenu;